import { FaPhone, FaEnvelope } from 'react-icons/fa'
import SEO from '../../lib/SEO'
import styles from './team.module.scss'

import logo from '../../assets/img/logo/vision.jpg'
import robertImg from '../../assets/img/team/r_matracki.jpg'
import yuriiImg from '../../assets/img/team/yurii.jpg'
import martinImg from '../../assets/img/team/martin.jpg'
import olgaImg from '../../assets/img/team/olga.jpg'
import jerryImg from '../../assets/img/team/jerry.jpg'
import julioImg from '../../assets/img/team/julio.jpeg'
import ulaImg from '../../assets/img/team/ula.jpeg'

interface Member {
  name: string
  role: string
  phone: string
  email: string
  photo?: string
}

const leadership: Member[] = [
  {
    name: 'Robert Matracki',
    role: 'President',
    phone: '630-504-2688',
    email: 'robert@vi4u.net',
    photo: robertImg,
  },
]

const dispatch: Member[] = [
  {
    name: 'Yurii Kostiukov',
    role: 'Ops Manager',
    phone: '630-504-2688',
    email: 'yurii@vi4u.net',
    photo: yuriiImg,
  },
  {
    name: 'Martin Wiciak',
    role: 'Dispatch',
    phone: '630-504-2688',
    email: 'martin@vi4u.net',
    photo: martinImg,
  },
  { name: 'Julio Quito', role: 'Dispatch', phone: '630-504-2688', email: 'julio@vi4u.net', photo: julioImg },
  { name: 'Stacey Whitney', role: 'Dispatch', phone: '630-504-2688', email: 'stacey@vi4u.net' },
  {
    name: 'Jerry Mastykash',
    role: 'Dispatch',
    phone: '630-504-2688',
    email: 'jerry@vi4u.net',
    photo: jerryImg,
  },
]

const accounting: Member[] = [
  {
    name: 'Olga Holtvianska',
    role: 'Head of Accounting',
    phone: '630-504-2688',
    email: 'olga@vi4u.net',
    photo: olgaImg,
  },
  { name: 'Magdalena Niewola', role: 'Billing', phone: '630-504-2688', email: 'magda@vi4u.net' },
]

const safety: Member[] = [
  {
    name: 'Urszula Kaczynski',
    role: 'Safety Manager',
    phone: '630-504-2688',
    email: 'safety@vi4u.net',
    photo: ulaImg,
  },
]

const MemberCard = ({ member, featured }: { member: Member; featured?: boolean }) => (
  <div className={`${styles.card} ${featured ? styles.cardFeatured : ''}`}>
    <div className={styles.cardPhoto}>
      <img
        src={member.photo ?? logo}
        alt={member.name}
        className={member.photo ? '' : styles.logoFallback}
      />
    </div>
    <div className={styles.cardBody}>
      <p className={styles.cardRole}>{member.role}</p>
      <h3 className={styles.cardName}>{member.name}</h3>
      <div className={styles.cardContacts}>
        <a
          href={`tel:${member.phone.replace(/-/g, '')}`}
          className={styles.cardLink}
        >
          <FaPhone /> {member.phone}
        </a>
        <a
          href={`mailto:${member.email}`}
          className={styles.cardLink}
        >
          <FaEnvelope /> {member.email}
        </a>
      </div>
    </div>
  </div>
)

const Section = ({
  label,
  title,
  members,
}: {
  label: string
  title: string
  members: Member[]
}) => (
  <div className={styles.section}>
    <div className={styles.sectionHeader}>
      <span className={styles.label}>{label}</span>
      <h2>{title}</h2>
    </div>
    <div className={styles.grid}>
      {members.map((m) => (
        <MemberCard
          key={m.email}
          member={m}
        />
      ))}
    </div>
  </div>
)

const Team = () => (
  <>
    <SEO
      title='Our Team – Vision International LLC'
      description="Meet the Vision International team. Dispatch, accounting, safety and leadership driving America's freight forward from Chicago, IL."
      keywords='Vision International team, dispatch team, trucking company staff'
      canonical='https://vi4u.net/team'
    />

    <div className={styles.page}>
      {/* HERO */}
      <div className={styles.hero}>
        <div className={styles.heroText}>
          <span className={styles.label}>Our Team</span>
          <h1>
            The people behind
            <br />
            <span className={styles.yellow}>every delivery.</span>
          </h1>
          <p>
            From dispatch to accounting, our team works around the clock to keep freight moving
            across all 48 states.
          </p>
        </div>
        <div className={styles.heroStats}>
          {[
            { n: '9', l: 'Team Members' },
            { n: '4', l: 'Departments' },
            { n: '24/7', l: 'Dispatch Coverage' },
            { n: '48', l: 'States Covered' },
          ].map((s) => (
            <div
              key={s.l}
              className={styles.heroStat}
            >
              <span className={styles.statN}>{s.n}</span>
              <span className={styles.statL}>{s.l}</span>
            </div>
          ))}
        </div>
      </div>

      {/* LEADERSHIP */}
      <div className={styles.leadershipWrap}>
        <div className={styles.sectionHeader}>
          <span className={styles.label}>Leadership</span>
          <h2>
            Executive <span className={styles.yellow}>Team</span>
          </h2>
        </div>
        <div className={styles.leadershipGrid}>
          {leadership.map((m) => (
            <MemberCard
              key={m.email}
              member={m}
              featured
            />
          ))}
        </div>
      </div>

      {/* DISPATCH */}
      <Section
        label='Dispatch'
        title='Dispatch Team'
        members={dispatch}
      />

      {/* ACCOUNTING */}
      <Section
        label='Accounting'
        title='Accounting Team'
        members={accounting}
      />

      {/* SAFETY */}
      <Section
        label='Safety'
        title='Safety Department'
        members={safety}
      />
    </div>
  </>
)

export default Team
